import { render } from "./SurveyView.vue?vue&type=template&id=3a611776"
import script from "./SurveyView.vue?vue&type=script&lang=js"
export * from "./SurveyView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__